import React, { useState, useEffect } from 'react';
import { Button, MenuItem, Select, InputLabel, FormControl, Typography, Box, Container } from '@mui/material';
// import Textarea from '@mui/joy/Textarea';
import { TextareaAutosize  as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
import { styled } from '@mui/system';

import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import axiosInstance from "../../interceptor/interceptor";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';

//Components
import IndexHeader from "../../Components/IndexHeader";
import Footer from '../../Components/Footer';

const defaultTheme = createTheme();
const blue = {
  100: '#DAECFF',
  200: '#b6daff',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  900: '#003A75',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};
const Textarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`,
);

const  ContactUs = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [inputField, setInputField] = React.useState({
    queryType: "",
    email: "",
    description: "",
  });

  const inputsHandler = (e) => {
      setInputField({ ...inputField, [e.target.name]: e.target.value });
  };

  useEffect(()=>{
    const queryParams = new URLSearchParams(window.location.search)
    const urlParam = queryParams.get("queryType");
    setInputField({ ...inputField, queryType: urlParam });

  }, []);
  const clearInputs = () => {
    setInputField({
      queryType: "",
      email: "",
      description: ""
    });
   document.getElementById('email').value="";
   document.getElementById('description').value="";
  }

  const handleSubmit = async (event) => {
      event.preventDefault();
      // Code for form validation
      if (inputField.queryType === "" || inputField.email=="" || inputField.description=="") {
        toast.info("Please fill all the medatory fields", { type: "error" });
        return false;
      }
  
      try{
        const obj = { ...inputField }
        setIsLoading(true);
        const res = await axiosInstance.post(
          `api?method=submit_contact_form`,
          obj
        );
        setIsLoading(false);
        clearInputs();
        toast(res.data.message);  
      }
      catch(e){
        setIsLoading(false);
        toast.info(`Error: ${e}`, { type: "error" });

      }
    };
    return(
        <>
        <IndexHeader />

        <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography style={{display: 'flex', justifyContent: 'center'}} variant="h4" component="h2">
            Contact Us
          </Typography>
          <FormControl fullWidth>
            <Box component="form" noValidate sx={{ mt: 1 }} style={{minHeight:'500px'}}>
                <InputLabel id="demo-simple-select-label">Make Selection</InputLabel>
                 <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Make Selection"
                value={inputField.queryType}
                fullWidth
                name="queryType"
                onChange={inputsHandler}
              >
                <MenuItem value={1}>Report a Problem</MenuItem>
                <MenuItem value={2}>Having a Suggestion</MenuItem>
                <MenuItem value={3}>Others</MenuItem>
              </Select>
               <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Your Email"
                name="email"
                autoComplete="email"
                onChange={inputsHandler}
              />
              <Textarea aria-label="minimum height" minRows={3} id="description" placeholder="Enter Description" name="description" onChange={inputsHandler} />
              {/* <Textarea minRows={2}  onChange={handleChange} /> */}
              {/* <TextField
                margin="normal"
                required
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
              /> */}
              {/* <TextareaAutosize
                margin="normal"
                required
                // fullWidth
                name="Description"
                label="Password"
              /> */}
              

              <Button onClick={handleSubmit}
                style={{margin: '0 auto', display: "flex", marginTop:'30px'}}
                type="button"
                // fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Submit
              </Button>

            </Box>
          </FormControl>
        </Box>
      </Container>
    </ThemeProvider>

    <Footer/>
    {isLoading == false ? (
        <></>
      ) : (
        <div id="overlay">
          <div className="loader">
            <CircularProgress />
          </div>
        </div>
      )}
        </>
    )
}

export default ContactUs